import { i18n } from "@lib/i18n";
import { globalLayoutRoute } from "@routes";
import { requireScope } from "@routes/authorization";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

export const homeRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `home`,
    component: lazyRouteComponent(() => import("./index")),
    beforeLoad: () => {
        requireScope("network");
        return { getTitle: () => i18n.doc_title_home() };
    },
});
